import React, { Component, useEffect, useState } from 'react'
import { View, Image, Linking, StyleSheet, Text, Modal } from 'react-native'
import { ScrollView, TextInput, TouchableOpacity } from 'react-native-gesture-handler'
import { Feather } from '@expo/vector-icons'
import theme from '../../../theme'
import styles from './VouchersScreenStyles'
import { apiUrl } from '../../config/config'
import { fetchAuthSession } from 'aws-amplify/auth'
import { RedeemVoucherScreen } from './RedeemVoucherScreen'
import { useBottomSheet } from '../customUtils/context/BottomSheetContext'
import CameraView from '../customUtils/CameraView'
import QRCameraView from '../customUtils/QRCameraView'
import VideoPlayerAV from '../customUtils/VideoPlayer/expo-av'
import { getLanguage } from '../appBar/context/LocalizationContext'
import { useNavigation } from '@react-navigation/native'
import { placeholderGeneral } from '../customUtils/Constants'
import { DateFormatter } from '../customUtils/DateFormatter'
import { getConection } from '../appBar/context/HeaderContext'
import moment from 'moment'
import { BottomSheetAlert } from '../modals/BottomSheetAlert'

export const VouchersScreen = () => {
    const { openBottomSheet, closeBottomSheet, updateSnapPoints } = useBottomSheet()

    const [showCamera, setShowCamera] = useState(false)
    const snapPoints = ['80%']
    const [code, setCode] = useState('')
    const navigation = useNavigation()
    const { languageFile } = getLanguage()
    const [historyRedeem, setHistoryRedeem] = useState([])
    const { isConnected, hasInternet } = getConection()
    const [isProcessingQR, setIsProcessingQR] = useState(false)
    const title = languageFile.scan_qr
    const desc = languageFile.scan_on_the_voucher
    // const canShowCamera = () => {
    //     let title = languageFile.scan_qr
    //     let desc = languageFile.scan_on_the_voucher

    //     openBottomSheet(<CameraView closeBottomSheet={closeBottomSheet} returnedValue={returnQR} title={title} description={desc} barcode={true} />, [
    //         '80%',
    //     ])
    //     // openBottomSheet(<QRCameraView title={title} returnQR={returnQR} />)
    // }
    const openRedeemSheet = (voucher, code_qr) => {
        openBottomSheet(
            <RedeemVoucherScreen
                data={voucher}
                closeRedeem={() => closeBottomSheet(true)}
                code_qr={code_qr}
                updateSnapPoints={updateSnapPoints}
                rejected={(t, d) => voucherRejectedModal(t, d)}
            />
        )
    }
    const returnQR = (text) => {
        setCode(text)
        redeemBenefit(text)
    }
    const redeemBenefit = async (text) => {
        if (isProcessingQR) {
            return
        }
        setIsProcessingQR(true)
        try {
            const session = await fetchAuthSession()
            const authToken = session.tokens.accessToken.toString()
            let headers = {
                'Content-Type': 'application/json',
                Authorization: authToken,
                code_qr: text,
            }

            const response = await fetch(`${apiUrl}/check_status_voucher`, {
                method: 'GET',
                headers: headers,
            })
            // console.log('🚀 ~ ValidateVoucher ~ response:', response)
            if (!response.ok) {
                const errorResponse = await response.json()
                throw new Error(`Fallo al verificar el voucher. Código de estado: ${response.status}. Detalles: ${JSON.stringify(errorResponse)}`)
            }

            const data = await response.json()

            if (data.status === 1) {
                if (data.single.status === 0) {
                    const title = data.single.message
                    const desc = data.single.description
                    console.log('🚀 ~ ValidateVoucher ~ title:', title)
                    setShowCamera(false)
                    voucherRejectedModal(title, desc)
                    setIsProcessingQR(false)
                } else {
                    setShowCamera(false)
                    openRedeemSheet(data.single.voucher, text)
                    setIsProcessingQR(false)
                }
            } else if (data.status === -1) {
                console.log('Hubo un error')
                setIsProcessingQR(false)
            }
        } catch (error) {
            console.log('🚀 ~ ValidateVoucher ~ error:', error)
            setIsProcessingQR(false)
        } finally {
            setIsProcessingQR(false)
        }
    }

    useEffect(() => {
        const unsubscribe = navigation.addListener('focus', () => {
            fetchHistoryRedeem()
        })
        return unsubscribe
    }, [navigation])

    const fetchHistoryRedeem = async () => {
        if (isConnected && hasInternet) {
            const session = await fetchAuthSession()
            const authToken = session.tokens.accessToken.toString()
            let headers = {
                'Content-Type': 'application/json',
                Authorization: authToken,
                type: 'voucher',
            }

            const response = await fetch(`${apiUrl}/get_benefits_history`, {
                method: 'GET',
                headers: headers,
            })

            if (!response.ok) {
                const errorResponse = await response.json()
                throw new Error(
                    `Fallo al obtener el historial de vouchers. Código de estado: ${response.status}. Detalles: ${JSON.stringify(errorResponse)}`,
                )
            }

            const data = await response.json()
            if (data.status === 1) {
                let history = data.single?.history_redeems ?? []
                setHistoryRedeem(history)
            }
        }
    }
    const voucherRejectedModal = (title, desc) => {
        const image = require('../../../assets/VoucherRejected.png')
        openBottomSheet(
            <BottomSheetAlert
                image={image}
                title={title}
                desc={desc}
                button={'Cerrar'}
                closeBottomSheet={closeBottomSheet}
                updateSnapPoints={updateSnapPoints}
            />,
            ['45%'],
        )
    }

    return (
        <>
            <View style={styles.container}>
                <Image style={styles.image} source={require('../../../assets/camaraQR.png')} />

                <Text style={styles.title}>{languageFile.validate_and_redeem_vouchers}</Text>
                <View style={styles.spacer}></View>
                <Text style={styles.description}>{languageFile.to_get_started}</Text>
                {/* <View style={styles.containerInput}>
                    <View style={styles.inputBlock}>
                        <TextInput
                            style={styles.input}
                            height={100}
                            onChangeText={onChangeText}
                            placeholder={languageFile.write_your_code}
                            placeholderTextColor={theme.colors.mediumGray}
                        />
                        <View style={styles.icon}>
                            <TouchableOpacity onPress={() => canShowCamera()}>
                                <Feather name='camera' size={24} color={theme.colors.colorPrimary} />
                            </TouchableOpacity>
                        </View>
                    </View>
                </View> */}
                <View style={styles.spacer1}></View>
                <View style={styles.buttonContainer}>
                    <TouchableOpacity
                        onPress={() => {
                            console.log('Click')
                            setShowCamera(true)
                        }}
                        style={styles.mainButton}
                    >
                        <Text style={styles.mainButtonText}>{languageFile.redeem}</Text>
                    </TouchableOpacity>
                    {historyRedeem.length > 0 && (
                        <TouchableOpacity
                            onPress={() => navigation.navigate('VouchersHistoryScreen', { history: historyRedeem })}
                            style={styles.floatingButton}
                        >
                            <Text style={styles.floatingButtonText}>{languageFile.view_history}</Text>
                        </TouchableOpacity>
                    )}
                </View>
            </View>

            <Modal visible={showCamera} animationType='slide'>
                <CameraView
                    closeBottomSheet={closeBottomSheet}
                    returnedValue={returnQR}
                    title={title}
                    description={desc}
                    barcode={true}
                    closeCameraModal={() => {
                        setShowCamera(false)
                        setIsProcessingQR(false)
                    }}
                />
            </Modal>
        </>
    )
}

export const VouchersHistoryScreen = ({ route }) => {
    let history = route.params.history
    const { languageFile } = getLanguage()

    return (
        <View style={styles.containerHistory}>
            <ScrollView showsVerticalScrollIndicator={false} style={{ flexGrow: 0, paddingBottom: 0 }} nestedScrollEnabled={true}>
                <Text style={styles.textSection}>{languageFile.voucher_history}</Text>
                <View style={styles.separator}></View>
                <Text style={styles.textSectionDescription}>{languageFile.voucher_history_description}</Text>
                <View style={styles.spacer1}></View>
                {history && history.length > 0 && history.map((item, index) => <VoucherHistoryItem key={index} item={item} />)}
                <View style={styles.spacer1}></View>
            </ScrollView>
        </View>
    )
}

export const VoucherHistoryItem = ({ item }) => {
    const [expanded, setExpanded] = useState(false)
    const [showMoreButton, setShowMoreButton] = useState(false)
    const { languageFile } = getLanguage()

    const handleTextLayout = (event) => {
        const { lines } = event.nativeEvent

        if (lines.length === 2 && !showMoreButton) {
            setShowMoreButton(true) // Mostrar el botón si las líneas exceden el límite
        }
    }

    let date = '2024-10-23T14:00:23.478Z'

    let formattedDate = moment(item.date).format('DD/MM/YYYY - HH:mm')
    let hasImage = item.image && item.image != '' ? true : false
    const code = item.voucher_code ? item.voucher_code + ' - ' : ''
    return (
        <View>
            <View style={styles.vouchersModule}>
                <Image
                    style={styles.voucherImage}
                    source={{
                        uri: hasImage ? item.image : placeholderGeneral,
                    }}
                />

                <View style={{ flex: 4, alignSelf: 'center' }}>
                    <Text style={styles.voucherDate}>{formattedDate}hs.</Text>

                    {item.name && <Text style={styles.voucherTitle}>{code + item.name}</Text>}
                    {item.description_long && (
                        <Text style={styles.voucherDescription} numberOfLines={expanded ? undefined : 2} onTextLayout={handleTextLayout}>
                            {item.description_long}
                        </Text>
                    )}
                    {item.store_name && item.store_code && (
                        <Text style={styles.voucherDescription}>{'Tienda: ' + item.store_code + ' - ' + item.store_name}</Text>
                    )}
                    <TouchableOpacity onPress={() => setExpanded(!expanded)}>
                        <Text style={styles.viewMore}>{expanded ? languageFile.see_less : languageFile.see_more}</Text>
                    </TouchableOpacity>
                </View>
            </View>
            <View style={styles.divider}></View>
        </View>
    )
}
